<script>
import Layout from "/src/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import Swal from "sweetalert2";
import ModalAddCronTask from "@/components/modals/monitor/cron_setup/modalAddCronTask.vue";
import ModalEditCronTask from "@/components/modals/monitor/cron_setup/modalEditCronTask.vue";

export default {
  components: { Layout, PageHeader, ModalAddCronTask, ModalEditCronTask },
  page: {
    title: "Cron Scheduled Tasks",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  created() {
    this.getCronScheduleTasks();
    this.getTenants();
  },
  methods: {
    modalAddNewCronScheduleTask() {
      this.$bvModal.show("add_cron_schedule_task");
    },
    getTenants() {
      Monitor.getTenants()
          .then((response) => {
            this.tenants = response.data.tenants;
          })
          .catch((error) => {});
    },

    getCronScheduleTasks() {
      this.isBusy = true;
      Monitor.getCronScheduleTasks(this.currentTenant)
        .then((response) => {
          this.tableData = response.data.data;
          this.totalRows = this.tableData.length;
          this.isBusy = false;
        })
        .catch((error) => {
          this.tableData = [];
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    resetFilter(){
      this.currentTenant = ''
      this.getCronScheduleTasks()
    },
    callmodalEditCronTask(item) {
      this.modalData = item;
      this.$bvModal.show("edit_cron_schedule_task");
    },
    deleteCronTask(id) {
      Swal.fire({
        title: "Delete Scheduled Cron Task?",
        text: "Remove this Scheduled Cron Task",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then((result) => {
        if (result.value) {
          Monitor.deleteCronScheduleTask(id)
            .then((response) => {
              const res = response.data ? response.data : false;
              const error = response.data.error
                ? response.data.error
                : "Failed";
              if (res) {
                this.getCronScheduleTasks();
                Swal.fire(
                  "Remove Application",
                  "Scheduled Cron Task Successfylly Deleted!",
                  "success"
                );
              } else {
                Swal.fire("Fail!", error, "warning");
              }
            })
            .catch((error) => {
              this.error = error.response.data.error
                ? error.response.data.error
                : "Delete Failed";
              this.failedmsg(this.error);
            });
        }
      });
    },
  },
  data() {
    return {
      title: "Cron Scheduled Tasks",
      items: [
        {
          text: "Cron Setup",
          href: "#",
        },
        {
          text: "Cron Scheduled Tasks",
          active: true,
        },
      ],
      isBusy: false,
      error: null,
      showModal: false,
      modalData: {},
      link_id: null,
      tenants: [],
      tableData: [],
      currentTenant: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],

      sortBy: "app_id",
      sortDesc: true,
      fields: [
        {
          key: "id",
          label: "Cron ID",
          sortable: true,
        },
        {
          key: "command",
          label: "Command",
          sortable: false,
        },
        {
          key: "tenant",
          label: "Tenant",
          sortable: false,
        },
        {
          key: "params",
          label: "Params",
          sortable: false,
        },
        {
          key: "expression",
          label: "Expression",
          sortable: true,
        },
        {
          key: "laravel_expression",
          label: "Laravel Expression",
          sortable: true,
        },
        {
          key: "background",
          label: "Background",
          sortable: true,
          class: 'text-center'
        },
        {
          key: "environment",
          label: "Environment",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "server",
          label: "Server",
          sortable: true,
        },
        {
          key: "active",
          label: "Active",
          sortable: true,
          class: 'text-center'
        },
        {
          key: "critical",
          label: "Critical",
          sortable: true,
          class: 'text-center'
        },
        {
          key: "last_run_at",
          label: "Last Run At",
          sortable: true,
        },
        "edit",
        "delete",
      ],
    };
  },
  destroyed() {},
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="">
              <div class="col-md-12 d-flex flex-row">
                <div class=" mb-3 d-flex flex-column col-3">
                  <label class="col-md-12 col-form-label d-flex" style="padding-left: 0px;">Select Tenant</label>
                  <select class="form-select" v-model="currentTenant" @change="getCronScheduleTasks" >
                    <option v-for="tenant in tenants" :key="tenant" :value="tenant">{{tenant}}</option>
                  </select>
              </div>
                <div class="mb-3 col-3 d-flex align-items-end">
                  <button type="button" class="btn btn-primary w-lg" @click="resetFilter">Reset</button>                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card pb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-success waves-effect waves-light"
                  @click="modalAddNewCronScheduleTask"
                >
                  <i class="mdi mdi-plus me-2"></i>
                  Add New Scheduled Cron Task
                </a>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive mb-0">
                <b-table
                  :busy="isBusy"
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  empty-text="No Data Found"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(server)="data">
                    <span v-if="data.item.server !== null">
                      {{ data.item.server }} |
                      {{ data.item.server_name }}
                    </span>
                  </template>

                  <template v-slot:cell(background)="data">
                    <span
                      class="badge font-size-14"
                      :class="
                        data.item.background === 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.background === 1 ? "Yes" : "No" }}
                    </span>
                  </template>
                  <template v-slot:cell(active)="data">
                    <span
                      class="badge font-size-14"
                      :class="
                        data.item.active === 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.active === 1 ? "Yes" : "No" }}
                    </span>
                  </template>

                  <template v-slot:cell(critical)="data">
                    <span
                            class="badge font-size-14"
                            :class="
                        data.item.critical === 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.critical === 1 ? "Yes" : "No" }}
                    </span>
                  </template>

                  <template v-slot:cell(edit)="data">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                          href="javascript:void(0);"
                          class="px-2 text-primary"
                          title="Edit"
                          @click="callmodalEditCronTask(data.item)"
                        >
                          <i class="uil uil-pen font-size-18"></i>
                        </a>
                      </li>
                    </ul>
                  </template>

                  <template v-slot:cell(delete)="data">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                          href="javascript:void(0);"
                          class="px-2 text-danger"
                          title="Remove"
                          @click="deleteCronTask(data.item.id)"
                        >
                          <i class="uil uil-trash-alt font-size-18"></i>
                        </a>
                      </li>
                    </ul>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <ModalAddCronTask @onRefresh="getCronScheduleTasks"></ModalAddCronTask>
    <ModalEditCronTask
      @onRefresh="getCronScheduleTasks"
      :modalData="modalData"
    ></ModalEditCronTask>
    <!-- /MODALS -->
  </Layout>
</template>
